import { useStorage } from '@vueuse/core'

declare type DialerState = {
  ready: boolean
  isCallOngoing: boolean
  isMuted: boolean
  isOpen: boolean
  isOpenConfig: boolean
  showOutbound: boolean
  showKeyPad: boolean
  showScreen: boolean
  showAcceptButton: boolean
  showRejectButton: boolean
  showHangupButton: boolean
  showTransferButton: boolean
  showVolumeIndicators: boolean
}

export default function useDialer() {
  const initialState = {
    ready: false,
    isCallOngoing: false,
    isMuted: false,
    isOpen: false,
    isOpenConfig: false,
    showOutbound: false,
    showKeyPad: false,
    showScreen: false,
    showAcceptButton: false,
    showRejectButton: false,
    showHangupButton: false,
    showTransferButton: false,
    showVolumeIndicators: false,
  }

  const parameters = useStorage<components['schemas']['CallParameters']>(
    'dialerParameters',
    {
      caller_id: '',
      to: '',
      Called: '',
      CallerId: '',
      FlowId: '',
      FlowName: '',
      ContentTypeAppLabel: '',
      ContentTypeModel: '',
      ObjectId: '',
      ObjectName: '',
    }
  )
  const state = useState<DialerState>('dialerState', () => initialState)
  let timerInterval: NodeJS.Timeout | undefined = undefined
  const timer = ref<number>(0)

  const resetState = () => (state.value = initialState)

  const initTimer = () => {
    timerInterval = setInterval(() => {
      timer.value++
    }, 1000)
  }

  const resetParameters = () => {
    parameters.value = {
      caller_id: '',
      to: '',
      Called: '',
      CallerId: '',
      FlowId: '',
      FlowName: '',
      ContentTypeAppLabel: '',
      ContentTypeModel: '',
      ObjectId: '',
      ObjectName: '',
    }
  }

  const resetTimer = () => {
    if (!timerInterval) return
    clearInterval(timerInterval)
  }

  return {
    initTimer,
    parameters,
    resetParameters,
    resetState,
    resetTimer,
    state,
    timer,
  }
}
